<template>
  <div class="rule-data-table">
    <table
      class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
    >
      <tbody>
        <tr v-for="(dataItem, dataIndex) in data" :key="dataIndex">
          <td
            v-for="(value, valueIndex) in dataItem"
            :key="valueIndex"
            :class="getCellClass(value)"
          >
            {{ formatCellValue(value) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "RuleDataTable",

  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  methods: {
    /**
     * Format cell value for display
     */
    formatCellValue(value) {
      if (value === null || value === undefined) {
        return "-";
      } else if (typeof value === "boolean") {
        return value ? this.$t("yes") : this.$t("no");
      } else if (typeof value === "number") {
        return value.toLocaleString();
      } else if (typeof value === "object") {
        return JSON.stringify(value);
      }

      return String(value);
    },

    /**
     * Get CSS class for cell based on value
     */
    getCellClass(value) {
      if (typeof value === "boolean") {
        return value ? "has-text-success" : "has-text-danger";
      }

      if (typeof value === "number" && value < 0) {
        return "has-text-danger";
      }

      return "";
    },
  },
};
</script>

<style scoped>
.rule-data-table {
  margin-top: 0.5rem;
}

.table {
  font-size: 0.875rem;
  background-color: hsl(0, 0%, 21%);
  color: hsl(0, 0%, 96%);
  border-color: hsl(0, 0%, 42%);
}

.table td {
  padding: 0.5rem 0.75rem;
  vertical-align: middle;
  background-color: hsl(0, 0%, 21%);
  border-color: hsl(0, 0%, 29%);
  color: hsl(0, 0%, 96%);
}

.table tr:hover td {
  background-color: hsl(0, 0%, 14%);
}

.table.is-striped tbody tr:nth-child(even) td {
  background-color: hsl(0, 0%, 14%);
}

.table.is-striped tbody tr:nth-child(even):hover td {
  background-color: hsl(0, 0%, 10%);
}

.has-text-success {
  color: hsl(153, 53%, 53%) !important;
}

.has-text-danger {
  color: hsl(348, 86%, 61%) !important;
}
</style>
